function contentHeight() {
  return window.innerHeight - 190
}

export default contentHeight
